export function Footer() {
  return (
    <div className="w-full bg-red py-10 text-center">
      <span className="text-base font-light text-black">
        Copyright © 2023 Acuity AI, All Rights Reserved
      </span>
    </div>
  );
}
